"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var modalHeader_1 = require("../../../actions/modalHeader");
var commonweb_utils_1 = require("commonweb-utils");
var addresses_1 = require("../../../actions/addresses");
var add_address_view_1 = require("./add-address.view");
var constants_1 = require("./constants");
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, links = _a.links, fpti = _a.fpti, deviceInfo = _a.deviceInfo;
    var addressData = account.addressData, addressFpti = fpti.address, properties = commonweb_utils_1.objectUtils.safeGet(addressData, "newAddress.entryMetadata.properties"), stateList = commonweb_utils_1.objectUtils.safeGet(properties, "state.list"), addressContent = content.addresses, commonContent = content.common, showNavigation = account.showNavigation, updatedForm = addressData.updatedForm;
    var addressAll = addressData.addresses, removeAddressId = route.enter.params.id, addressToRemove = addressAll.find(function (add) { return add.id === removeAddressId; }), cardList = commonweb_utils_1.objectUtils.safeGet(addressToRemove, "cardList") || [];
    var addContext = {
        type: constants_1.ADDRESS.REMOVE_BILLING_TYPE,
        removeAddressId: removeAddressId,
        isRemovePrimary: commonweb_utils_1.objectUtils.safeGet(addressToRemove, "primary") || false,
        cardIds: cardList.map(function (card) { return card.id; }),
    };
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        addressData: addressData,
        addressContent: addressContent,
        commonContent: commonContent,
        links: links,
        addressFpti: addressFpti,
        stateList: stateList,
        showNavigation: showNavigation,
        deviceInfo: deviceInfo,
        addContext: addContext,
        updatedForm: updatedForm,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchAddAddress: function (addressInfo) {
            return dispatch(addresses_1.buildAddress(addressInfo));
        },
        addAction: function (typeOfAction) { return dispatch(addresses_1.actionType(typeOfAction)); },
        changeHeaderVisibility: function (value) { return dispatch(modalHeader_1.showNavigation(value)); },
        updateForm: function (value) { return dispatch(addresses_1.updateForm(value)); },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(add_address_view_1.default);
